import React, { useState, useEffect } from "react";
import {
  FaFacebookF,
  FaInstagram,
  FaLinkedin,
  FaYoutube,
} from "react-icons/fa";

import { Link, useNavigate, useLocation } from "react-router-dom";
import { HashLink } from "react-router-hash-link";

const Footer = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [activeLink, setActiveLink] = useState(null);

  useEffect(() => {
    setActiveLink(location.pathname + location.hash);
  }, [location]);

  const handleLinkClick = (path) => {
    setActiveLink(path);
  };

  const isActive = (path) => {
    return activeLink === path;
  };

  return (
    <footer className="text-gray-800 text-sm bg-[#F3F1F1]">
      {/* Upper Section */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-10 pb-8 border-b border-gray-300">
        {/* Grid container */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-6 gap-6">
          {/* Left Column: Logo + Social */}
          <div className="col-span-1 lg:col-span-2 flex flex-col items-center lg:items-start">
            {/* Logo */}
            <img
              src="https://dbqa318yoj3nn.cloudfront.net/SIMPLIFYING%20SKILLS%201.png"
              alt="Simplifying Skills"
              className="w-[280px] lg:w-[320px] h-auto"
            />

            {/* Follow Us */}
            <p className="font-bold mt-4 lg:mt-2 text-center lg:text-left lg:ml-[85px] text-sm font-montserrat" style={{ fontFamily: "Poppins" }}>
              FOLLOW US ON:
            </p>

            {/* Social Icons */}
            <div className="mt-2 lg:mt-1 px-4 py-2 lg:ml-7 rounded-md flex gap-6 items-center justify-center w-full max-w-[280px]">
              <a
                href="https://www.youtube.com/@simplifyingskills"
                target="_blank"
                rel="noreferrer"
                aria-label="YouTube"
              >
                <FaYoutube className="text-red-600 text-2xl hover:scale-110 transition" />
              </a>
              {/* <a
                href="https://www.facebook.com/SimplifyingSkillsConsultants"
                target="_blank"
                rel="noreferrer"
                aria-label="Facebook"
              >
                <FaFacebookF className="text-blue-700 text-2xl hover:scale-110 transition" />
              </a> */}
              <a href="https://www.facebook.com/SimplifyingSkillsConsultants" target="_blank" rel="noopener noreferrer" aria-label="Visit our Facebook page">
                  <img 
                 src="https://upload.wikimedia.org/wikipedia/commons/5/51/Facebook_f_logo_%282019%29.svg" 
                 alt="Facebook" 
                 className="hover:scale-110 transition"
                   style={{width: "30px", height: "30px"}}
               />
              </a>

              <a
                href="https://www.instagram.com/simplifying_skills/"
                target="_blank"
                rel="noreferrer"
                aria-label="Instagram"
              >
                <FaInstagram className="text-pink-600 text-2xl hover:scale-110 transition" />
              </a>
              <a
                href="https://www.linkedin.com/company/simplifying-skills-consultants/"
                target="_blank"
                rel="noreferrer"
                aria-label="LinkedIn"
              >
                <FaLinkedin className="text-blue-700 text-2xl hover:scale-110 transition" />
              </a>
            </div>
          </div>
          
          {/* Right Columns - Navigation Links */}
          <div className="grid grid-cols-2 lg:grid-cols-4 lg:col-span-4 gap-6">
            {/* About Us */}
            <div className="text-center lg:text-left">
              <h3
                className="text-blue-700 text-lg md:text-[19px] font-semibold mb-2 font-montserrat cursor-pointer"
                onClick={() => navigate("/about-us")} style={{ fontFamily: "Poppins" }}
              >
                About Us
              </h3>
              <ul className="flex flex-col items-center lg:items-start space-y-1 font-semibold font-montserrat">
                <li>
                  <HashLink
                    to="/about-us#vision"
                    smooth
                    className={`${isActive("/about-us#vision") ? "text-blue-600 underline" : "hover:text-blue-600 hover:underline"} cursor-pointer transition-all duration-200`}
                    onClick={() => handleLinkClick("/about-us#vision")} style={{ fontFamily: "Poppins" }}
                  >
                    Vision
                  </HashLink>
                </li>
                <li>
                  <HashLink
                    to="/about-us#vision"
                    smooth
                    className={`${isActive("/about-us#vision") ? "text-blue-600 underline" : "hover:text-blue-600 hover:underline"} cursor-pointer transition-all duration-200`}
                    onClick={() => handleLinkClick("/about-us#vision")} style={{ fontFamily: "Poppins" }}
                  >
                    Mission
                  </HashLink>
                </li>
                <li>
                  <HashLink
                    to="/about-us#values"
                    smooth
                    className={`${isActive("/about-us#values") ? "text-blue-600 underline" : "hover:text-blue-600 hover:underline"} cursor-pointer transition-all duration-200`}
                    onClick={() => handleLinkClick("/about-us#values")} style={{ fontFamily: "Poppins" }}
                  >
                    Values
                  </HashLink>
                </li>
                <li>
                  <HashLink
                    to="/about-us#whatwedo"
                    smooth
                    className={`${isActive("/about-us#whatwedo") ? "text-blue-600 underline" : "hover:text-blue-600 hover:underline"} cursor-pointer transition-all duration-200`}
                    onClick={() => handleLinkClick("/about-us#whatwedo")} style={{ fontFamily: "Poppins" }}
                  >
                    What we do
                  </HashLink>
                </li>
                <li>
                  <HashLink
                    to="/about-us#whyus"
                    smooth
                    className={`${isActive("/about-us#whyus") ? "text-blue-600 underline" : "hover:text-blue-600 hover:underline"} cursor-pointer transition-all duration-200`}
                    onClick={() => handleLinkClick("/about-us#whyus")} style={{ fontFamily: "Poppins" }}
                  >
                    Why Us
                  </HashLink>
                </li>
                <li>
                  <HashLink
                    to="/about-us#team"
                    smooth
                    className={`${isActive("/about-us#team") ? "text-blue-600 underline" : "hover:text-blue-600 hover:underline"} cursor-pointer transition-all duration-200`}
                    onClick={() => handleLinkClick("/about-us#team")} style={{ fontFamily: "Poppins" }}
                  >
                    Team
                  </HashLink>
                </li>
                <li>
                  <HashLink
                    to="/career"
                    smooth
                    className={`${isActive("/career") ? "text-blue-600 underline" : "hover:text-blue-600 hover:underline"} cursor-pointer transition-all duration-200`}
                    onClick={() => handleLinkClick("/career")} style={{ fontFamily: "Poppins" }}
                  >
                    Career
                  </HashLink>
                </li>
              </ul>
            </div>

            {/* Research */}
            <div className="text-center lg:text-left">
              <h3 className="text-blue-700 text-lg md:text-[19px] font-semibold mb-2 font-montserrat" style={{ fontFamily: "Poppins" }}>
                Research
              </h3>
              <ul className="flex flex-col items-center lg:items-start space-y-1 font-semibold font-montserrat" style={{ fontFamily: "Poppins" }}>
                <li>
                  <Link
                    to="/ocean"
                    className={`${isActive("/ocean") ? "text-blue-600 underline" : "hover:text-blue-600 hover:underline"} cursor-pointer transition-all duration-200`}
                    onClick={() => handleLinkClick("/ocean")} style={{ fontFamily: "Poppins" }}
                  >
                    OCEAN
                  </Link>
                </li>
                <li>
                  <Link
                    to="/baronmodel"
                    className={`${isActive("/baronmodel") ? "text-blue-600 underline" : "hover:text-blue-600 hover:underline"} cursor-pointer transition-all duration-200`}
                    onClick={() => handleLinkClick("/baronmodel")} style={{ fontFamily: "Poppins" }}
                  >
                    Bar-on Model
                  </Link>
                </li>
                <li>
                  <Link
                    to="/riasec"
                    className={`${isActive("/riasec") ? "text-blue-600 underline" : "hover:text-blue-600 hover:underline"} cursor-pointer transition-all duration-200`}
                    onClick={() => handleLinkClick("/riasec")} style={{ fontFamily: "Poppins" }}
                  >
                    RIASEC
                  </Link>
                </li>
                <li>
                  <Link
                    to="/core"
                    className={`${isActive("/core") ? "text-blue-600 underline" : "hover:text-blue-600 hover:underline"} cursor-pointer transition-all duration-200`}
                    onClick={() => handleLinkClick("/core")} style={{ fontFamily: "Poppins" }}
                  >
                    CORE
                  </Link>
                </li>
                <li>
                  <Link
                    to="/Dat"
                    className={`${isActive("/Dat") ? "text-blue-600 underline" : "hover:text-blue-600 hover:underline"} cursor-pointer transition-all duration-200`}
                    onClick={() => handleLinkClick("/Dat")} style={{ fontFamily: "Poppins" }}
                  >
                    DAT
                  </Link>
                </li>
                <li>
                  <Link
                    to="/nep"
                    className={`${isActive("/nep") ? "text-blue-600 underline" : "hover:text-blue-600 hover:underline"} cursor-pointer transition-all duration-200`}
                    onClick={() => handleLinkClick("/nep")} style={{ fontFamily: "Poppins" }}
                  >
                    NEP 2020
                  </Link>
                </li>
                <li>
                  <Link
                    to="/stem"
                    className={`${isActive("/stem") ? "text-blue-600 underline" : "hover:text-blue-600 hover:underline"} cursor-pointer transition-all duration-200`}
                    onClick={() => handleLinkClick("/stem")} style={{ fontFamily: "Poppins" }}
                  >
                    STEM
                  </Link>
                </li> 
              </ul>
            </div>

            {/* Offerings */}
            <div className="text-center lg:text-left">
              <h3 className="text-blue-700 text-lg md:text-[19px] font-semibold mb-2 font-montserrat" style={{ fontFamily: "Poppins" }}> 
                Offering
              </h3>
              <ul className="flex flex-col items-center lg:items-start space-y-1 font-semibold font-montserrat" style={{ fontFamily: "Poppins" }}>
                <li>
                  <Link
                    to="/global"
                    className={`${isActive("/global") ? "text-blue-600 underline" : "hover:text-blue-600 hover:underline"} transition-all cursor-pointer duration-200`}
                    onClick={() => handleLinkClick("/global")} style={{ fontFamily: "Poppins" }}
                  >
                    Global Exposure
                  </Link>
                </li>
                <li>
                  <Link
                    to="/fellowship"
                    className={`${isActive("/fellowship") ? "text-blue-600 underline" : "hover:text-blue-600 hover:underline"} cursor-pointer transition-all duration-200`}
                    onClick={() => handleLinkClick("/fellowship")} style={{ fontFamily: "Poppins" }}
                  >
                    Fellowship Grant
                  </Link>
                </li>
              </ul>

              <h3 className="text-blue-700 text-lg md:text-[19px] font-semibold mb-2 mt-4 font-montserrat" style={{ fontFamily: "Poppins" }}>
                Other
              </h3>
              <ul className="flex flex-col items-center lg:items-start space-y-1 font-semibold font-montserrat" style={{ fontFamily: "Poppins" }}>
                <li>
                  <Link
                    to="/blog"
                    className={`${isActive("/blog") ? "text-blue-600 underline" : "hover:text-blue-600 hover:underline"} cursor-pointer transition-all duration-200`}
                    onClick={() => handleLinkClick("/blog")} style={{ fontFamily: "Poppins" }}
                  >
                    Blogs
                  </Link>
                </li>
                <li>
                  <Link
                    to="/faq"
                    className={`${isActive("/faq") ? "text-blue-600 underline" : "hover:text-blue-600 hover:underline"} cursor-pointer transition-all duration-200`}
                    onClick={() => handleLinkClick("/faq")} style={{ fontFamily: "Poppins" }}
                  > 
                    FAQs
                  </Link>
                </li>
                <li>
                  <a
                    href="/terms-and-conditions"
                    className={`${isActive("/terms-and-conditions") ? "text-blue-600 underline" : "hover:text-blue-600 hover:underline"} cursor-pointer transition-all duration-200`}
                    onClick={() => handleLinkClick("/terms-and-conditions")} style={{ fontFamily: "Poppins" }}
                  >
                    Terms & Conditions
                  </a>
                </li>
                <li>
                  <a
                    href="/privacy-policy"
                    className={`${isActive("/privacy-policy") ? "text-blue-600 underline" : "hover:text-blue-600 hover:underline"} cursor-pointer transition-all duration-200`}
                    onClick={() => handleLinkClick("/privacy-policy")} style={{ fontFamily: "Poppins" }}
                  >
                    Privacy Policy
                  </a>
                </li>
              </ul>
            </div>

            {/* Clubs Section */}
            <div className="text-center lg:text-left">
              <h3 className="text-blue-700 text-lg md:text-[19px] font-semibold mb-2 font-montserrat" style={{ fontFamily: "Poppins" }}>
                Club
              </h3>
              <ul className="flex flex-col items-center lg:items-start space-y-1 font-semibold font-montserrat" style={{ fontFamily: "Poppins" }}>
                <li>
                  <Link
                    to="/entrepreneurship"
                    className={`${isActive("/entrepreneurship") ? "text-blue-600 underline" : "hover:text-blue-600 hover:underline"} transition-all duration-200`}
                    onClick={() => handleLinkClick("/entrepreneurship")} style={{ fontFamily: "Poppins" }}
                  >
                    Entrepreneurship League
                  </Link>
                </li>
                <li>
                  <Link
                    to="/engineeringexplorers"
                    className={`${isActive("/engineeringexplorers") ? "text-blue-600 underline" : "hover:text-blue-600 hover:underline"} transition-all duration-200`}
                    onClick={() => handleLinkClick("/engineeringexplorers")} style={{ fontFamily: "Poppins" }}
                  >
                    Engineering Explorers
                  </Link>
                </li>
                <li>
                  <Link
                    to="/medicalmavericks"
                    className={`${isActive("/medicalmavericks") ? "text-blue-600 underline" : "hover:text-blue-600 hover:underline"} transition-all duration-200`}
                    onClick={() => handleLinkClick("/medicalmavericks")} style={{ fontFamily: "Poppins" }}
                  >
                    Medical Mavericks
                  </Link>
                </li>
                <li>
                  <Link
                    to="/artisticvisionaries"
                    className={`${isActive("/artisticvisionaries") ? "text-blue-600 underline" : "hover:text-blue-600 hover:underline"} transition-all duration-200`}
                    onClick={() => handleLinkClick("/artisticvisionaries")} style={{ fontFamily: "Poppins" }}
                  >
                    Artistic Visionaries
                  </Link>
                </li>
                <li>
                  <Link
                    to="/businesstrailbazars"
                    className={`${isActive("/businesstrailbazars") ? "text-blue-600 underline" : "hover:text-blue-600 hover:underline"} transition-all duration-200`}
                    onClick={() => handleLinkClick("/businesstrailbazars")} style={{ fontFamily: "Poppins" }}
                  >
                    Business Trailblazers
                  </Link>
                </li>
                <li>
                  <Link
                    to="/administrativeAchievers"
                    className={`${isActive("/administrativeAchievers") ? "text-blue-600 underline" : "hover:text-blue-600 hover:underline"} transition-all duration-200`}
                    onClick={() => handleLinkClick("/administrativeAchievers")} style={{ fontFamily: "Poppins" }}
                  >
                    Administrative Achievers
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      {/* Text Content Section */}
      <div className="px-4 py-8 sm:px-8 lg:px-20 max-w-8xl mx-auto text-gray-800 font-montserrat">
        {/* About Us */}
        <section className="mb-8">
          <h2 className="text-blue-600 text-xl font-bold mb-2 text-center sm:text-left" style={{ fontFamily: "Poppins" }}>
            About Us
          </h2>
          <p className="mb-2 text-base md:text-[17px] leading-normal text-center sm:text-left font-poppins" style={{ fontFamily: "Poppins" }}>At
            <strong style={{ fontFamily: "Poppins" }}> Simplifying Skills</strong> we are dedicated to transforming the educational experience by providing students with opportunities that go beyond the traditional classroom. Through innovative, world-class programs, we partner with schools, parents, and students to nurture<strong style={{ fontFamily: "Poppins" }}> holistic development, </strong>foster global perspectives, and prepare young minds for the challenges and opportunities of the future.
          </p>
          {/* <p className="mb-2 text-base md:text-[17px] leading-relaxed text-center sm:text-left font-poppins" style={{ fontFamily: "Poppins" }}>
            We offer a <strong style={{ fontFamily: "Poppins" }}>free assessment</strong> to analyze students strengths and interests, providing them with a <strong style={{ fontFamily: "Poppins" }}>roadmap for their future</strong>. While the assessment itself is free, we provide a detailed and insightful report as a paid offering. Furthermore, to support exceptional talent, we reward the top 10 students with up to <strong style={{ fontFamily: "Poppins" }}>₹1 crore</strong> in financial assistance and provide the top 40 students with opportunities to gain <strong style={{ fontFamily: "Poppins" }}>Global exposure</strong>.
          </p> */}
        </section>

        {/* What Makes Us Different */}
        <section className="mb-8">
          <h2 className="text-blue-600 text-xl font-bold mb-2 text-center sm:text-left" style={{ fontFamily: "Poppins" }}>
            What Makes Us Different
          </h2>
          <ul className="space-y-3 text-base md:text-[17px] leading-normal text-center sm:text-left font-poppins" style={{ fontFamily: "Poppins" }}>
            <li style={{ fontFamily: "Poppins" }}>
              <strong style={{ fontFamily: "Poppins" }}>Holistic Development:</strong> We focus on nurturing not just skills but also confidence, vision, and overall growth of each student.
            </li>
            <li style={{ fontFamily: "Poppins" }}>
              <strong style={{ fontFamily: "Poppins" }}>Future-Focused:</strong> We equip students with skills, tools, and insights to prepare them for tomorrow's competitive world.
            </li>
            <li style={{ fontFamily: "Poppins" }}>
              <strong style={{ fontFamily: "Poppins" }}>Verified Frameworks:</strong> Our assessments use validated and reliable methodologies developed by prominent <strong style={{ fontFamily: "Poppins" }}>psychologists and scientists</strong> to identify the true capabilities of each student.
            </li>
            <li style={{ fontFamily: "Poppins" }}>
              <strong style={{ fontFamily: "Poppins" }}>Comprehensive Career Planning:</strong> Beyond identifying skills, we actively assist students in crafting their <strong style={{ fontFamily: "Poppins" }}>academic and career strategies</strong>.
            </li>
            <li style={{ fontFamily: "Poppins" }}>
              <strong style={{ fontFamily: "Poppins" }}>Unmatched Support:</strong> From <strong style={{ fontFamily: "Poppins" }}>financial assistance</strong> to <strong style={{ fontFamily: "Poppins" }}>global exposure</strong>, we go the extra mile to support top talent.
            </li>
          </ul>
        </section>

        {/* Why Choose Us */}
        <section>
          <h2 className="text-blue-600 text-xl font-bold mb-2 text-center sm:text-left" style={{ fontFamily: "Poppins" }}>
            Why Choose Us
          </h2>
          <ul className="space-y-3 text-base md:text-[17px] leading-normal text-center sm:text-left font-poppins">
            <li style={{ fontFamily: "Poppins" }}>
              <strong style={{ fontFamily: "Poppins" }}>Holistic Assessments:</strong> Our assessment and evaluation strategies are developed by professionals to ensure they are <strong style={{ fontFamily: "Poppins" }}>accurate, effective, and relevant</strong> for each student.
            </li>
            <li style={{ fontFamily: "Poppins" }}>
              <strong style={{ fontFamily: "Poppins" }}>Personalized Guidance:</strong> We believe every student is unique, and our personalized approach ensures each student receives guidance based on their <strong style={{ fontFamily: "Poppins" }}>own potential and aspirations</strong>.
            </li>
            <li style={{ fontFamily: "Poppins" }}>
              <strong style={{ fontFamily: "Poppins" }}>Global Opportunities & Fellowships:</strong> We offer a chance to gain international exposure to high-performing students through visits to top institutes like <strong style={{ fontFamily: "Poppins" }}>NASA</strong> and <strong style={{ fontFamily: "Poppins" }}>Harvard</strong>. We also offer <strong style={{ fontFamily: "Poppins" }}>Fellowship grants</strong> to students with innovative ideas to encourage them to <strong style={{ fontFamily: "Poppins" }}>achieve their dreams</strong>.
            </li>
          </ul>
        </section>
      </div>

      {/* Copyright Section */}
      <div className="bg-blue-950 text-white py-3 text-xs flex justify-center items-center relative">
        <span className="absolute right-1 sm:left-[62%] transform -translate-x-1/2 ml-2 font-montserrat">
          ©2025 All Rights Reserved Simplifying Skills
        </span>
        <button
          onClick={() => navigate("/login")}
          className="absolute right-6 px-2 font-semibold  bg-blue-950   hover:bg-white text-blue-950 rounded  transition font-montserrat"
          aria-label="Admin login"
        >
          Admin
        </button>
      </div>
    </footer>
  );
};

export default Footer;